import React from 'react';
import { Users, TrendingUp } from 'lucide-react';

interface SegmentStatsCardProps {
  totalSize: number;
  totalInteractions: number;
  avgEngagementRate: number;
}

export const SegmentStatsCard: React.FC<SegmentStatsCardProps> = ({
  totalSize,
  totalInteractions,
  avgEngagementRate,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Segment Size */}
      <div className="bg-v11-surface border border-v11-border rounded-lg p-4">
        <div className="flex items-center gap-2 mb-2">
          <Users className="h-4 w-4 text-blue-500" />
          <span className="text-sm text-v11-text-secondary">Segment Size</span>
        </div>
        <div className="text-2xl font-bold text-v11-text-primary">
          {totalSize.toLocaleString()}
        </div>
        <div className="text-xs text-v11-text-muted mt-1">profiles</div>
      </div>

      {/* Total Interactions */}
      <div className="bg-v11-surface border border-v11-border rounded-lg p-4">
        <div className="flex items-center gap-2 mb-2">
          <TrendingUp className="h-4 w-4 text-green-500" />
          <span className="text-sm text-v11-text-secondary">Total Interactions</span>
        </div>
        <div className="text-2xl font-bold text-v11-text-primary">
          {(totalInteractions / 1000000).toFixed(1)}M
        </div>
        <div className="text-xs text-v11-text-muted mt-1">engagements</div>
      </div>

      {/* Avg Engagement Rate */}
      <div className="bg-v11-surface border border-v11-border rounded-lg p-4">
        <div className="flex items-center gap-2 mb-2">
          <TrendingUp className="h-4 w-4 text-purple-500" />
          <span className="text-sm text-v11-text-secondary">Avg. Engagement</span>
        </div>
        <div className="text-2xl font-bold text-v11-text-primary">
          {avgEngagementRate.toFixed(1)}%
        </div>
        <div className="text-xs text-v11-text-muted mt-1">engagement rate</div>
      </div>
    </div>
  );
};
